module.exports = __webpack_public_path__ + "img/games-8.4ca2ea57.jpg";